//Load more btn for people page

// News page ajax
let newsCurrentPage = 1;

function setupForm($ = jQuery) {
  const $form = $("#checkbox-filter");
  if (!$form.length) {
    return;
  }
  const $grid = $("#news-grid-content");
  $grid.addClass("loading");
  const $latestNews = $(".latest-news");
  const parsePageFromHref = (href) => {
    if (!href) {
      return 1;
    }
    const pagedMatch = href.match(/[?&]paged=(\d+)/);
    if (pagedMatch && pagedMatch[1]) {
      return parseInt(pagedMatch[1], 10);
    }
    const prettyMatch = href.match(/\/page\/(\d+)\/?/);
    if (prettyMatch && prettyMatch[1]) {
      return parseInt(prettyMatch[1], 10);
    }
    return 1;
  };
  const updatePagination = (paginationHtml) => {
    const trimmedHtml = (paginationHtml || "").trim();
    const $existingPagination = $grid.siblings(".pagination").first();
    if (!trimmedHtml) {
      $existingPagination.remove();
      return;
    }
    if ($existingPagination.length) {
      $existingPagination.replaceWith(trimmedHtml);
    } else {
      $grid.after(trimmedHtml);
    }
  };

  const hasActiveFilters = () => {
    return $form.find('input[type="checkbox"]:checked').length > 0;
  };

  const updateFeaturedVisibility = (page = 1) => {
    if (!$latestNews.length) {
      return;
    }
    if (page > 1 || hasActiveFilters()) {
      $latestNews.hide();
      return;
    }
    $latestNews.show();
  };

  const runFilterRequest = (page = 1) => {
    $grid.addClass("loading");
    newsCurrentPage = page;
    $form.find("input[name='paged']").val(page);
    //use the history api to remove the current page and add the new page '/page/{page}/'
    //remove the last / from the url if it exists
    const newUrl = window.location.href.replace(/\/$/, "").replace(/(\/page\/\d+\/?)/, "") + (page > 1 ? `/page/${page}/` : "");
    window.history.replaceState(null, "", newUrl);
    updateFeaturedVisibility(page);
    $.ajax({
      type: $form.attr("method") || "POST",
      url: barker_brettell_ajax.url,
      dataType: "json",
      data: $form.serialize(),
      success: function (res) {
        if (!res || !res.success || !res.data) {
          return;
        }
        $(".button-open").removeClass("button-open");
        $grid.html(res.data.html);
        $grid.removeClass("loading");
        $('.posts-content').show();
        updatePagination(res.data.pagination);
        updateFeaturedVisibility(newsCurrentPage);
        if ($('.filters').hasClass('active')) {
          $('.filters').removeClass('active');
        }
      },
    });
  };

  $form.on("submit", function (e) {
    e.preventDefault();
    runFilterRequest(1);
  });
  $form.find('input[type="search"]').on("input", function () {
    runFilterRequest(1);
  });

  $grid.parent().on("click", ".pagination a", function (e) {
    e.preventDefault();
    const nextPage = parsePageFromHref($(this).attr("href"));
    console.log("Next page:", nextPage);
    runFilterRequest(nextPage);
    //smooth scroll to the top of the grid
    $("html, body").animate({
        scrollTop: $grid.offset().top - 200,
    }, 500);
  });

  $(".clear-btn").each(function () {
    $(this).on("click", function (e) {
      e.preventDefault();
      $form.find('input[type="checkbox"]').prop("checked", false);
      $('span.selected').html('');
      runFilterRequest(1);
    });
  });

  $(window).on("load", function () {
    const urlParams = new URLSearchParams(window.location.search);
    let pageParam = urlParams.get("paged");
    if (!pageParam) {
      pageParam = parsePageFromHref(window.location.href);
    }
    console.log("Page param from URL:", pageParam);
    const page = pageParam ? parseInt(pageParam, 10) : 1;
    runFilterRequest(page);
  });
}

jQuery(function ($) {
  setupForm($);

  const $peopleForm = $("#checkbox-filter-people");
  const $staffForm = $("#checkbox-filter-staff");
  const $resourceForm = $("#checkbox-filter-resource");
  const $peopleList = $(".people-list");
  const $staffList = $(".staff-list");
  const $resourceList = $(".posts-grid");
  const $noResults = $(".no-results");
  const $loadMoreWrap = $(".load-more-btn");
  const $loadMoreBtn = $("#load-more");

  const parsePageFromHref = (href) => {
    if (!href) {
      return 1;
    }
    const pagedMatch = href.match(/[?&]paged=(\d+)/);
    if (pagedMatch && pagedMatch[1]) {
      return parseInt(pagedMatch[1], 10);
    }
    const prettyMatch = href.match(/\/page\/(\d+)\/?/);
    if (prettyMatch && prettyMatch[1]) {
      return parseInt(prettyMatch[1], 10);
    }
    return 1;
  };
  const updatePagination = (paginationHtml) => {
    const trimmedHtml = (paginationHtml || "").trim();
    const $existingPagination = $resourceList.siblings(".pagination").first();
    if (!trimmedHtml) {
      $existingPagination.remove();
      return;
    }
    if ($existingPagination.length) {
      $existingPagination.replaceWith(trimmedHtml);
    } else {
      $resourceList.after(trimmedHtml);
    }
  };

  $resourceList.parent().on("click", ".pagination a", function (e) {
    e.preventDefault();
    const nextPage = parsePageFromHref($(this).attr("href"));
    runResourceRequest(nextPage);
    //smooth scroll to the top of the grid
    $("html, body").animate({
        scrollTop: $resourceList.offset().top - 200,
    }, 500);
  });

  let loadingMore = false;
  let currentPage = 1;
  let maxPages = parseInt($loadMoreWrap.attr("data-max-pages"), 10) || 1;

  const updateResourcePagination = () => {
    console.log(currentPage, maxPages);
    if (currentPage == 1 && maxPages == 1) {
      $('.pagination').hide();
    } else {
      $('.pagination').show();
    }
  };

  const updatePeoplePagination = () => {
    if (!$loadMoreWrap.length) {
      return;
    }

    if (currentPage >= maxPages) {
      $loadMoreWrap.hide();
      return;
    }

    $loadMoreWrap.show();
  };

  const updateStaffPagination = () => {
    if (!$loadMoreWrap.length) {
      return;
    }

    if (currentPage >= maxPages) {
      $loadMoreWrap.hide();
      return;
    }

    $loadMoreWrap.show();
  };

  const updateNoResults = (totalPosts = 0) => {
    if (!$noResults.length) {
      return;
    }

    if (totalPosts > 0) {
      $noResults.hide();
      return;
    }

    $noResults.show();
  };

  const runResourceRequest = (page = 1, append = false) => {
    $resourceForm.find('input[name="paged"]').val(page);
    console.log("Running resource request for page:", page, "append:", append);
    if (!$resourceForm.length || !$resourceList.length) {
      return;
    }

    if (loadingMore) {
      return;
    }
    
    loadingMore = true;
    const requestData = $resourceForm.serializeArray();

    console.log("Requesting resource page:", barker_brettell_ajax.url, requestData);

    $.ajax({
      type: $resourceForm.attr("method") || "POST",
      url: barker_brettell_ajax.url,
      dataType: "json",
      data: $.param(requestData),
      success: function (res) {
        if (!res || !res.success || !res.data) {
          return;
        }

        const html = res.data.html || "";
        const totalPosts = parseInt(res.data.total_posts, 10) || 0;

        if (append) {
          $resourceList.append(html);
        } else {
          $resourceList.html(html);
        }

        currentPage = parseInt(res.data.current_page, 10) || page;
        maxPages = parseInt(res.data.max_pages, 10) || 1;
        updatePagination(res.data.pagination);
        updateNoResults(totalPosts);
        $('.posts-content').addClass('visible');
      },
      complete: function () {
        loadingMore = false;
      },
    });
  };

  const runPeopleRequest = (page = 1, append = false) => {
    if (!$peopleForm.length || !$peopleList.length) {
      return;
    }

    if (loadingMore) {
      return;
    }

    loadingMore = true;
    const requestData = $peopleForm.serializeArray();
    requestData.push({ name: "paged", value: page });

    $.ajax({
      type: $peopleForm.attr("method") || "POST",
      url: barker_brettell_ajax.url,
      dataType: "json",
      data: $.param(requestData),
      success: function (res) {
        if (!res || !res.success || !res.data) {
          return;
        }

        const html = res.data.html || "";
        const totalPosts = parseInt(res.data.total_posts, 10) || 0;

        if (append) {
          $peopleList.append(html);
        } else {
          $peopleList.html(html);
        }

        currentPage = parseInt(res.data.current_page, 10) || page;
        maxPages = parseInt(res.data.max_pages, 10) || 1;
        updatePeoplePagination();
        updateNoResults(totalPosts);
        $('.posts-content').show();
      },
      complete: function () {
        loadingMore = false;
      },
    });
  };

  const runStaffRequest = (page = 1, append = false) => {
    if (!$staffForm.length || !$staffList.length) {
      return;
    }

    if (loadingMore) {
      return;
    }

    loadingMore = true;
    const requestData = $staffForm.serializeArray();
    requestData.push({ name: "paged", value: page });
    console.log("Requesting staff page:", requestData);

    $.ajax({
      type: $staffForm.attr("method") || "POST",
      url: barker_brettell_ajax.url,
      dataType: "json",
      data: $.param(requestData),
      success: function (res) {
        if (!res || !res.success || !res.data) {
          return;
        }

        const html = res.data.html || "";
        const totalPosts = parseInt(res.data.total_posts, 10) || 0;

        if (append) {
          $staffList.append(html);
        } else {
          $staffList.html(html);
        }

        currentPage = parseInt(res.data.current_page, 10) || page;
        maxPages = parseInt(res.data.max_pages, 10) || 1;
        updateStaffPagination();
        updateNoResults(totalPosts);
        if ($('.filters').hasClass('active')) {
          $('.filters').removeClass('active');
        }
        $('.posts-content').show();
      },
      complete: function () {
        loadingMore = false;
      },
    });
  };

  $resourceForm.on("submit", function (e) {
    e.preventDefault();
    currentPage = parseInt($resourceForm.find('input[name="paged"]').val(), 10) || 1;
    runResourceRequest(currentPage, false);
  });

  $peopleForm.on("submit", function (e) {
    e.preventDefault();
    currentPage = 1;
    runPeopleRequest(1, false);
  });

  $staffForm.on("submit", function (e) {
    e.preventDefault();
    currentPage = 1;
    runStaffRequest(1, false);
  });

  $(".submit-btn-resource").on("click", function (e) {
    e.preventDefault();
    $resourceForm.find('input[name="paged"]').val(1);
    $resourceForm.trigger("submit");
  });

  $(".submit-btn-people").on("click", function (e) {
    e.preventDefault();
    $peopleForm.trigger("submit");
  });

  $(".submit-btn-staff").on("click", function (e) {
    e.preventDefault();
    $staffForm.trigger("submit");
  });

  $("body").on("click", "#load-more", function (e) {
    e.preventDefault();
    if (loadingMore || currentPage >= maxPages) {
      return;
    }
    if ($resourceForm.length) {
      runResourceRequest(currentPage + 1, true);
    }
    if ($peopleForm.length) {
      runPeopleRequest(currentPage + 1, true);
    }
    if ($staffForm.length) {
      runStaffRequest(currentPage + 1, true);
    }
  });

  updatePeoplePagination();

  //check when we scroll if the #load-more button is visible and within 200px of the bottom of the viewport, if so trigger a click on it
  $(window).on("scroll", function () {
    const $loadMoreBtn = $("#load-more");
    if ($loadMoreBtn.length && $loadMoreBtn.is(":visible")) {
      const loadMoreOffset = $loadMoreBtn.offset().top;
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      if (scrollTop + windowHeight >= loadMoreOffset - 200) {
        $loadMoreBtn.trigger("click");
      }
    }
  });
  if ($('body.post-type-archive-resource').length || $('body.tax-resource-location').length || $('body.tax-resource-language').length || $('body.tax-resource-type').length) {
    currentPage = 1;
    runResourceRequest(1, false);
  }
});

jQuery(function ($) {
  const $clearBtn = jQuery(".clear-btn");
  const $peopleCheckboxes = jQuery('input[type="checkbox"]');
  $clearBtn.each(function () {
    jQuery(this).on("click", function (e) {
      e.preventDefault();
      if ($peopleCheckboxes.is(":checked")) {
        $peopleCheckboxes.prop("checked", false).trigger("change");
      }
    });
  });
});